export default __webpack_public_path__ + "static/media/danger.79483abd.svg";